import { CURRENT_PRODUCT_MODE } from '@utils/constants';
const productKey = CURRENT_PRODUCT_MODE === 'EI' ? '-' : `-${CURRENT_PRODUCT_MODE}-`;

export const SCOPE = 'tempDashboard';
export const prefix = `TEMP${productKey}DASHBOARD`;

export const INIT = `${SCOPE}/INIT`;
export const INIT_AT_COMPONENT = `${SCOPE}/INIT_AT_COMPONENT`;
export const SET_KEYS = `${SCOPE}/SET_KEYS`;
export const SET_KEY = `${SCOPE}/SET_KEY`;
export const REMOVE_KEY = `${SCOPE}/REMOVE_KEY`;
export const REMOVE_ALL_KEYS = `${SCOPE}/REMOVE_ALL_KEYS`;

export const SET_SAVED_RECENTLY_KEYS = `${SCOPE}/SET_SAVED_RECENTLY_KEYS`;
export const SET_SAVED_RECENTLY_KEY = `${SCOPE}/SET_SAVED_RECENTLY_KEY`;
export const REMOVE_SAVED_RECENTLY_KEY = `${SCOPE}/REMOVE_SAVED_RECENTLY_KEY`;

export const TOGGLE_UPDATE_POPUP_VISIBLE = `${SCOPE}/TOGGLE_UPDATE_POPUP_VISIBLE`;
export const SET_AFTER_INITIALIZATION = `${SCOPE}/AFTER_INITIALIZATION`;

export const CREATE_TEMP_DASHBOARD = `${SCOPE}/CREATE_TEMP_DASHBOARD`;
export const UPDATE_DASHBOARD_TITLE = `${SCOPE}/UPDATE_DASHBOARD_TITLE`;
export const UPDATE_TEMP_DASHBOARD_BY_TITLE = `${SCOPE}/UPDATE_TEMP_DASHBOARD_BY_TITLE`;
export const CREATE_SAVED_DASHBOARD = `${SCOPE}/CREATE_SAVED_DASHBOARD`;
export const UPDATED_SAVED_DASHBOARD = `${SCOPE}/UPDATED_SAVED_DASHBOARD`;
export const RESET_SAVED_DASHBOARD = `${SCOPE}/RESET_SAVED_DASHBOARD`;

export const SET = `${SCOPE}/SET`;
export const SET_SAVED = `${SCOPE}/SET_SAVED`;
export const REMOVE = `${SCOPE}/REMOVE`;
export const REMOVE_ALL = `${SCOPE}/REMOVE_ALL`;
export const REFRESH_TABS = `${SCOPE}/REFRESH_TABS`;
export const UPDATE_ACTIVE_DASHBOARD = `${SCOPE}/UPDATE_ACTIVE_DASHBOARD`;

export const UPDATE_ACCESSED_TIME = `${SCOPE}/UPDATE_ACCESSED_TIME`;
export const CLEAN_TEMP_DASHBOARDS = `${SCOPE}/CLEAN_TEMP_DASHBOARDS`;
